<script>
import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
// import API from "../../../../../config/api.js";
export default {
  name: "buttonEditor",
  mixins: [componentEditorMixin],
  data() {
    return {
      myVar: '',
      colorFlag: 0,
      tmpBtnColor: '',
      tmpBorderColor: '',
      formList: [
        'buttonForm'
      ],
      ruleList: [
        //buttonForm
        {
          text:[

          ],
          txtColor:[
            {
              required: true,
              message: '请选择文本颜色'
            }
          ],
          txtSize: [
            {
              required: true,
              message: '请输入字体大小'
            },
            {
              type: 'number',
              message: '字体大小输入数字'
            },
          ],
          txtStyle: [
            {
              required: true,
              message: '请选择字体样式'
            }
          ],
          txtDecoration: [
            {
              required: true,
              message: '请选择文字装饰'
            }
          ],
          txtPosition: [
            {
              required: true,
              message: '请选择文字对齐方式'
            }
          ],
          btnColor: [
            {
              required: true,
              message: '请选择颜色'
            }
          ],
          btnBorderColor: [
            {
              required: true,
              message: '请选择颜色'
            }
          ],
          btnEffectColor: [
            {
              required: true,
              message: '请选择颜色'
            }
          ],
          btnEffect:[{}]
        },
      ],
      //页面跳转
      pageList:[

      ],
      //字体样式
      txtStyleList: [
        {
          value: 'Times New Roman',
          name: 'Times New Roman'
        },
        {
          value: 'Arial',
          name: 'Arial'
        },
        {
          value: 'Georgia',
          name: 'Georgia'
        },
        {
          value: '宋体',
          name: '宋体'
        },
        {
          value: '黑体',
          name: '黑体'
        }
      ],
      txtDecorationList: [
        {
          value: 'overline',
          name: '上划线'
        },
        {
          value: 'underline',
          name: '下划线'
        },
        {
          value: 'none',
          name: '无'
        }
      ],
      txtPositionList:[
        {
          value: 'left',
          name: '左对齐'
        },
        {
          value: 'center',
          name: '居中'
        },
        {
          value: 'right',
          name: '右对齐'
        }
      ],
      btnEffectList:[
        {
          value: 'open',
          name: '开启'
        },
        {
          value: 'close',
          name: '关闭'
        }
      ],
      selectList1:[
        {
          value: 0,
          label: '子窗口'
        }, {
          value: 1,
          label: '全窗口'
        },
      ],
      // selectValue1:'', //模态非模态选中值
      selectList2:[
        {
          value: 0,
          label: '项目页面'
        }, {
          value: 1,
          label: '变量历史'
        },
        {
          value: 2,
          label: '变量报警'
        },
      ],
      // selectValue2:'', //页面类型选中值
      selectList3: [],   //页面选择
      // selectValue3:'', //选中的具体页面
      selectValue4:[],//变量的选择
      selectList4:[],//变量的列表

      //模态窗的大小输入框
      // modalvalue: '',
      //type: 'Number',  //输入的类型
      border: true,  //有边框
      height: 30,    //输入框的大小
    }
  },

  computed: {
    specificForms() {
      return (
          <div class="specificForms">
            <el-collapse-item class="specificForm" title="按钮效果选项">
              <template slot="default">
                <div class="specificForm">
                  <el-form id="buttonForm" {...{attrs: {model: this.newSettings}}} ref="buttonForm"  label-style={this.formLabelStyle}>
                    <el-form-item label="显示文本" prop="text" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.text,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"显示文本"
                        }}}{...{on: {
                          'input': val => {
                            this.newSettings.text = val
                            this.handleConfirmBtnClick()
                          },
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="文本颜色" prop="txtColor" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.txtColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"文本颜色"
                        }}}{...{on: {
                          'input': val =>{
                            this.textColorChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="字号" prop="txtSize" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.txtSize,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"字号"
                        }}}{...{on: {
                          'input': val=>{
                            this.handleTxtSizeChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="字体" prop="txtStyle" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.txtStyle,
                          type: 'select',
                          selectList: this.txtStyleList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"字体"
                        }}}{...{on: {
                          'input': val=>{
                            this.handleTxtStyleChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="文字装饰" prop="txtDecoration" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.txtDecoration,
                          type: 'radio',
                          radioList: this.txtDecorationList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"文字装饰"
                        }}}{...{on: {
                          'input': val=>{
                            this.txtDecorationChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="字体对齐方式" prop="txtPosition" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.txtPosition,
                          type: 'radio',
                          radioList: this.txtPositionList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"字体对齐方式"
                        }}}{...{on: {
                          'input': val=>{
                            this.txtPositionChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="按钮颜色" prop="btnColor" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.btnColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"按钮颜色"
                        }}}{...{on: {
                          'input': val=>{
                            this.btnColorChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="边框颜色" prop="btnBorderColor" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.btnBorderColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"边框颜色"
                        }}}{...{on: {
                          'input':val=>{
                            this.btnBorderColorChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="立体颜色" prop="btnEffectColor" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.btnEffectColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"立体颜色"
                        }}}{...{on: {
                          'input': val=>{
                            this.btnEffectColorChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="立体效果" prop="btnEffect" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.boxShadow,
                          type: 'switch',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"立体效果"
                        }}}{...{on: {
                          'input': val=>{
                            this.btnEffectChange(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                    <el-form-item label="闪烁" prop="flash" label-position={this.labelPosition}>
                      <editor-field {...{attrs: {
                          value: this.newSettings.flash,
                          type: 'switch',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                          label:"闪烁"
                        }}}{...{on: {
                          'input': val=>{
                            this.btnFlash(val)
                            this.handleConfirmBtnClick()
                          }
                        }}}>
                      </editor-field>
                    </el-form-item>
                  </el-form>
                </div>
              </template>
            </el-collapse-item>
          </div>
      )
    },
    // jumpForms() {
    //   return (
    //       <div class="jumpForms">
    //         <el-collapse-item class="jumpForms" title="跳转页面效果">
    //           <template slot="default">
    //             <div class="jumpForms">
    //               <div class="div">
    //                 <select
    //                     {...{attrs: {
    //                         value: this.newSettings.selectValue1,
    //
    //                       }}}
    //                     {...{on: {
    //                         'input': e => {
    //                           this.newSettings.selectValue1 = e.target.value;
    //                           this.newSettings.pageId = '';
    //                           this.selectValue4 = [];
    //                           if(document.getElementById('pageList')){
    //                             document.getElementById('pageList').selectedIndex = 0;
    //                           }
    //                           if(document.getElementById('varList')){
    //                             document.getElementById('varList').selectedIndex = 0;
    //                           }
    //                           this.handleConfirmBtnClick()
    //                         }
    //                       }
    //                     }}
    //                     style={{marginLeft:'5px',marginBottom:'3px',width:'110px' }}>
    //                   {
    //                     [
    //                       (<option value="">跳转方式</option>),
    //                       ...this.selectList1.map(item => {
    //                         return item.value == this.newSettings.selectValue1 ? (
    //                             <option value={item.value} selected={true}>{item.label}</option>
    //                         ) : (
    //                             <option value={item.value}>{item.label}</option>
    //                         )
    //                       })
    //                     ]
    //
    //                   }
    //                 </select>
    //
    //                 { /*
    //         <select
    //           {...{attrs: {
    //               value: this.newSettings.selectValue2,
    //             }}}
    //           {...{on: {
    //               'input': e => {
    //               this.newSettings.selectValue2 = e.target.value
    //               console.log('begin');
    //               this.newSettings.pageId = '';
    //               this.selectValue4 = [];
    //               if(document.getElementById('pageList')){
    //                 document.getElementById('pageList').selectedIndex = 0;
    //               }
    //               if(document.getElementById('varList')){
    //                 document.getElementById('varList').selectedIndex = 0;
    //               }
    //             }
    //             }
    //           }}
    //         style={{marginLeft:'5px',marginBottom:'3px',width:'110px' }}>
    //           {
    //             [
    //             (<option value="">页面类型</option>),
    //               ...this.selectList2.map(item => {
    //                 return item.value == this.newSettings.selectValue2 ? (
    //                   <option value={item.value} selected={true}>{item.label}</option>
    //                 ) : (
    //                   <option value={item.value}>{item.label}</option>
    //                 )
    //               })
    //             ]
    //
    //           }
    //         </select> */}
    //
    //                 { /*<el-select v-model={this.newSettings.selectValue2} placeholder="页面类型">
    //
    //         {
    //             this.selectList2.map(item => {
    //               return  ( <el-option
    //                                key={item.value}
    //                                label={item.label}
    //                                value={item.value}>
    //                                </el-option>)
    //             })
    //
    //
    //         }
    //         </el-select> */}
    //                 {  /*
    //        this.newSettings.selectValue2 == 0 ? (
    //            <select id='pageList'
    //             {...{attrs: {
    //                 value: this.newSettings.pageId,
    //               }}}
    //             {...{on: {
    //                 'input': e => {
    //                   this.newSettings.pageId =e.target.value,
    //                   this.btnFlag(e.target.value)}
    //
    //               }
    //             }}
    //             style={{marginLeft:'5px',width:'110px' }}>
    //             {
    //               [
    //               (<option value="">页面选择</option>),
    //                 ...this.selectList3.map(item => {
    //                   return item.value == this.newSettings.pageId ? (
    //                     <option value={item.id} selected={true}>{item.title}</option>
    //                   ) : (
    //                     <option value={item.id}>{item.title}</option>
    //                   )
    //                 })
    //               ]
    //
    //             }
    //            </select>
    //         )
    //          : (
    //            <select id='varList'
    //             {...{attrs: {
    //                 value: this.selectValue4,
    //               }}}
    //             {...{on: {
    //                 'input': e => {
    //               if(this.selectValue4.indexOf(e.target.value)==-1)
    //               this.selectValue4.push( e.target.value)
    //               else {
    //                 for(var i=0;i<selectValue4.length;i++)
    //                    {
    //                      if(selectValue4[i]== e.target.value )
    //                         selectValue4.splice(i,1)
    //                    }
    //                 }
    //               this.newSettings.varIds =this.selectValue4,
    //               this.btnFlag(e.target.value)
    //               }
    //
    //               }
    //
    //             }}
    //             style={{marginLeft:'5px',width:'110px' }}>
    //             {
    //               [
    //                 (<option value="">变量选择</option>),
    //               ...Object.keys(this.varJson).map(item => {
    //
    //                   return (this.selectValue4.indexOf( this.varJson[item].id) !=-1) ? (
    //                     <option value={this.varJson[item].id} selected={true}>{item}</option>
    //                   ) : (
    //                     <option value={this.varJson[item].id}>{item}</option>
    //                   )
    //                 })
    //               ]
    //
    //             }
    //            </select>
    //
    //         )   */}
    //                 {
    //                   <select id='pageList'
    //                           {...{attrs: {
    //                               value: this.newSettings.pageId,
    //                             }}}
    //                           {...{on: {
    //                               'input': e => {
    //                                 this.newSettings.pageId =e.target.value,
    //                                     this.btnFlag(e.target.value)
    //                                 this.handleConfirmBtnClick()
    //                               }
    //                             }
    //                           }}
    //                           style={{marginLeft:'5px',width:'110px' }}>
    //                     {
    //                       [
    //                         (<option value="">页面选择</option>),
    //                         ...this.selectList3.map(item => {
    //                           return item.id == this.newSettings.pageId ? (
    //                               <option value={item.id} selected={true}>{item.title}</option>
    //                           ) : (
    //                               <option value={item.id}>{item.title}</option>
    //                           )
    //                         })
    //                       ]
    //
    //                     }
    //                   </select>
    //                 }
    //                 {
    //                   this.newSettings.selectValue1==0 ? (
    //                           <div style={{marginTop:'5px',marginLeft:'5px',width:'110px',display: 'inline-block' }}>
    //                             <el-input  border-color="#000000"
    //                                        type="number" min="0" border={this.border}  height={this.height}  placeholder="模态窗宽度"
    //                                  // v-model={this.newSettings.modalValue}
    //                                        {...{
    //                                          attrs: {
    //                                            value: this.newSettings.modalValue,
    //                                          }
    //                                        }}
    //                                        {...{
    //                                          on: {
    //                                            'input': val => {
    //                                              this.newSettings.modalValue = val
    //                                              this.handleConfirmBtnClick()
    //                                            },
    //                                          }
    //                                        }}
    //                             />
    //
    //                           </div>
    //
    //                       )
    //                       : (
    //                           <div style={{width:'110px',marginTop:'5px',marginLeft:'5px',display: 'inline-block'}}>
    //                             <el-input clearable={true} border-color="#000000"
    //                                       type="number" min="0" border={this.border}  height={this.height}  disabled={true} placeholder="禁止输入"
    //                             />
    //                           </div>
    //                       )
    //                 }
    //                 {
    //                   this.newSettings.selectValue1==0 ? (
    //                           <div style={{marginTop:'5px',marginLeft:'5px',width:'110px',display: 'inline-block' }}>
    //                             <el-input  border-color="#000000"
    //                                        type="number"  border={this.border}  height={this.height}  placeholder="模态窗高度"
    //                                         // v-model={this.newSettings.modalHeight}
    //                                        {...{
    //                                          attrs: {
    //                                            value: this.newSettings.modalHeight,
    //                                          }
    //                                        }}
    //                                        {...{
    //                                          on: {
    //                                            'input': val => {
    //                                              this.newSettings.modalHeight = val
    //                                              this.handleConfirmBtnClick()
    //                                            },
    //                                          }
    //                                        }}
    //                             />
    //
    //                           </div>
    //
    //                       )
    //                       : (
    //                           <div style={{width:'110px',marginTop:'5px',marginLeft:'5px',display: 'inline-block'}}>
    //                             <el-input clearable={true} border-color="#000000"
    //                                       type="number"  border={this.border}  height={this.height}  disabled={true} placeholder="禁止输入"
    //                             />
    //                           </div>
    //                       )
    //                 }
    //               </div>
    //             </div>
    //           </template>
    //         </el-collapse-item>
    //       </div>
    //   )
    // },

  },
  mounted() {
    this.newInit();

  },
  methods: {
  //   btnFlag(val){
  //     if(val == ''){
  //       this.newSettings.flag = false
  //     }
  //     else{
  //       this.newSettings.flag = true
  //     }
  //     for(let i=0;i<this.selectList3.length;i++){
  //       if(this.selectList3[i].id == val){
  //         this.newSettings.product_type = this.selectList3[i].product_type;
  //         this.newSettings.projectId = this.selectList3[i].projectId;
  //       }
  //     }
  //
  //   },
  //   newInit(){
  //     let header = {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //     }
  //
  //   let data = {
  //     companyId: this.companyId,
  //     projectId: this.projectId,
  //     product_type: 0
  //   }
  //   console.log(data)
  //   this.$axiosRequest({
  //     url: API.getProductPublishedList,
  //     method: 'POST',
  //     data: data,
  //     header: header,
  //     success: res => {
  //       this.selectList3 = res.data["productPublishedList"]
  //     }
  //   });
  // },
    textColorChange(val){
      this.styleMergeObj = {
        ...this.styleMergeObj,
        color : val
      }
      this.newSettings.txtColor = val
    },
    handleTxtSizeChange(val){
      this.styleMergeObj = {
        ...this.styleMergeObj,
        'font-size' : val + 'px'
      }
      this.newSettings.txtSize = val
    },
    handleTxtStyleChange(val){
      this.styleMergeObj = {
        ...this.styleMergeObj,
        'font-family' : val
      }
      this.newSettings.txtStyle = val
    },
    txtDecorationChange(val){
      this.styleMergeObj = {
        ...this.styleMergeObj,
        'text-decoration' : val
      }
      this.newSettings.txtDecoration = val
    },
    txtPositionChange(val){
      this.styleMergeObj = {
        ...this.styleMergeObj,
        'justify-content' : val
      }
      this.newSettings.txtPosition = val
    },
    btnColorChange(val){
      this.styleMergeObj = {
        ...this.styleMergeObj,
        'background-color' : val
      }
      this.newSettings.btnColor = val
    },
    btnBorderColorChange(val){
      this.styleMergeObj = {
        ...this.styleMergeObj,
        'border-color' : val
      }
      this.newSettings.btnBorderColor = val
    },
    btnEffectColorChange(val){
      console.log('qqqqqqqq',val)
      this.newSettings.btnEffectColor = val
      if(this.newSettings.boxShadow == true){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'box-shadow' : '3px 4px 0px 0px' + val
        }
      }
    },
    btnEffectChange(val){
      if(val == true){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'box-shadow' : '3px 4px 0px 0px ' + this.newSettings.btnEffectColor
        }
        this.newSettings.boxShadow = val
      }
      if(val == false){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'box-shadow' : 'none'
        }
        this.newSettings.boxShadow = val
      }
    },
    //按钮闪烁
    btnFlash(val){
      this.newSettings.flash = val
      if(val == true){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'animation-play-state' : 'running',
        }
      }
      else if(val == false){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'animation-play-state' : 'paused',
        }
      }
    },
    btnState(val,attr){
      this.$set(this.newSettings, attr, val)
    }
  }
}
</script>

  <style>
  .singleSelect{
    height: 30px;
    line-height: 30px;
    width: 100%;
    border-radius: 5px;
    padding: 0 10px;
  }
  </style>
